import angular from 'angular';
import moment from 'moment';

import adminpulse from '@/shared/utils/adminpulse';
import { emptyGuid } from '@/shared/utils/guid';
import { getPercentageColorClass } from '@/modules/relations/budgets/budgetHelpers';
angular
  .module('cloudX')
  .controller('InvoiceStreamBudgetDialogCtrl', [
    '$http',
    'dialogsSvc',
    'flySvc',
    '$element',
    'close',
    'stream',
    'readOnly',
    'appUrls',
    'checkSecurity',
    invoiceStreamBudgetDialogCtrl,
  ]);

const mapBudget = data => {
  if (!data) {
    return null;
  }
  data.percentageAmount = data.budgetAmount ? (data.actualAmount || 0) / data.budgetAmount : null;
  data.percentageHours = data.budgetHours ? (data.actualHours || 0) / data.budgetHours : null;
  data.amountClass = getPercentageColorClass(data.percentageAmount);
  data.hoursClass = getPercentageColorClass(data.percentageHours);
  return data;
};

function invoiceStreamBudgetDialogCtrl(
  $http,
  dialogsSvc,
  flySvc,
  $element,
  close,
  stream,
  readOnly,
  appUrls,
  checkSecurity,
) {
  var vm = this;
  vm.lines = [];
  vm.hasChanges = false;
  vm.years = [];
  vm.readOnly = readOnly;

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };
  vm.recalcYears = function() {
    const currentYear = moment.utc().year();
    vm.years = [];
    for (let y = currentYear - 3; y <= currentYear + 1; y++) {
      if (vm.lines && !vm.lines.some(x => x.year === y)) {
        vm.years.push(y);
      }
    }
  };
  $http.get(`${appUrls.api}/api/Budget/All/${stream.id}`).then(({ data }) => {
    vm.lines = (data || []).map(mapBudget);
    vm.recalcYears();
  }, showError);

  vm.cancel = function() {
    close(vm.hasChanges, 500);
  };
  vm.saveBudget = function(line, field, data) {
    //Validation error
    if (typeof data === 'undefined') return '';
    if (angular.equals(line, data)) return false;
    var model = angular.copy(line);
    model[field] = data;
    vm.hasChanges = true;
    return $http.put(`${appUrls.api}/api/budget/`, model).then(({ data }) => {
      const newBudget = mapBudget(data);
      angular.extend(line, newBudget);
      return false;
    }, showError);
  };

  vm.deleteBudget = function(line) {
    if (!line || !line.id) return;
    if (line.id === emptyGuid) {
      var idx = vm.lines.indexOf(line);
      if (idx >= 0) vm.lines.splice(idx, 1);
      return;
    }
    dialogsSvc.showYesNo('msgConfirmDeleteTitle', 'msgDeleteBudget').then(function() {
      line.deleting = true;
      $http.delete(`${appUrls.api}/api/Budget/${line.id}`).then(function() {
        vm.hasChanges = true;
        flySvc.success();
        var idx = vm.lines.indexOf(line);
        if (idx >= 0) vm.lines.splice(idx, 1);

        vm.recalcYears();
        return false;
      }, showError);
    });
  };

  vm.addBudget = function(year) {
    const model = {
      invoiceStreamId: stream.id,
      year,
      budgetAmount: null,
      budgetHours: null,
    };
    return $http.put(`${appUrls.api}/api/budget/`, model).then(({ data }) => {
      const newBudget = mapBudget(data);
      vm.lines.push(newBudget);
      vm.recalcYears();
      return false;
    }, showError);
  };
}
